import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// components
import LoadingScreen from '../components/loading-screen';
//
import { useAuthContext } from './useAuthContext';

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: React.ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isInitialized, user } = useAuthContext();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Navigate to="/auth/login" state={{ from: pathname }} replace />;
  }

  // Handle role-based redirection if user is generic landing
  if (pathname === '/' || pathname === '/dashboard' || pathname === '/dashboard/') {
    const userRole = (user as any)?.role;
    if (userRole === 'AGENT') {
      return <Navigate to="/agent" replace />;
    }
    if (userRole === 'VOICE_AGENT') {
      return <Navigate to="/agent/voice-queue" replace />;
    }
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <> {children} </>;
}
